import { enums } from '../../../gads'
import { Improvement } from '../../improvement'
import { Targets } from '../../..'
import * as TargetFactory from '../../../target-factory/target_factory'

export enum EntityLevel {
    AD_GROUP_MULTI = 'ad_group_multi',
}

export type ValidLookbackWindow =
    | Improvement.LookbackWindow.FOURTEEN_DAYS
    | Improvement.LookbackWindow.THIRTY_DAYS
    | Improvement.LookbackWindow.NINETY_DAYS

export const ValidAdvertisingChannelTypes = {
    SEARCH: enums.AdvertisingChannelType.SEARCH,
    DISPLAY: enums.AdvertisingChannelType.DISPLAY,
    SHOPPING: enums.AdvertisingChannelType.SHOPPING,
} as const

export type ValidAdvertisingChannelType =
    (typeof ValidAdvertisingChannelTypes)[keyof typeof ValidAdvertisingChannelTypes]

export const ValidBiddingStrategyTypes = {
    TARGET_CPA: enums.BiddingStrategyType.TARGET_CPA,
    TARGET_ROAS: enums.BiddingStrategyType.TARGET_ROAS,
    MAXIMIZE_CONVERSIONS: enums.BiddingStrategyType.MAXIMIZE_CONVERSIONS,
    MAXIMIZE_CONVERSION_VALUE: enums.BiddingStrategyType.MAXIMIZE_CONVERSION_VALUE,
} as const

export type ValidBiddingStrategyType =
    (typeof ValidBiddingStrategyTypes)[keyof typeof ValidBiddingStrategyTypes]

/** Extends enum InvalidTargetReason from TargetFactory with some improvement specific invalid reasons */
export const InvalidTargetReason = {
    ...TargetFactory.InvalidTargetReason,
    MINIMUM_CLICKS_NOT_MET: 'MINIMUM_CLICKS_NOT_MET',
    LATEST_TARGET_CHANGE_WITHIN_WINDOW: 'LATEST_TARGET_CHANGE_WITHIN_WINDOW',
} as const

export type InvalidTargetReason = (typeof InvalidTargetReason)[keyof typeof InvalidTargetReason]

export type CampaignGroup = {
    id: string
    name: string
    target_is_auto_mode: boolean
    desired_target?: number
}

export type Body = {
    entity_level: EntityLevel
    window: ValidLookbackWindow
    performance_mode: Targets.PerformanceMode
    currency: string
    campaign_group: CampaignGroup & {
        metrics: {
            all_conversions: number
            clicks: number
            multiplier: number
        }
    }
    campaign: {
        resource_name: string
        name: string
        bidding_strategy_type: ValidBiddingStrategyType
        advertising_channel_type: ValidAdvertisingChannelType
        is_budget_capped: boolean
        existing_target: number
        metrics: {
            clicks: number
            cost: number
            all_conversions: number
            all_conversions_value: number
        }
        minimum_clicks: number
    }
}

export type ExtraDetails = {
    new_target: number
    resource_name: string
    ad_group_id?: number
}
